/* eslint-disable operator-linebreak */
/* eslint-disable no-lonely-if */
/* eslint-disable no-else-return */
/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable object-curly-newline */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-alert */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable max-len */
import React, { useState, memo } from "react";

import { useLocation } from "react-router-dom";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { chainedSort, descDate } from "../../logic/utility/sort";
import Environments from "../../Environments";
import MOCK_DATA from "../../mock/data";
import { TRAINING_TYPE_CAREER, TRAINING_TYPE_CURRICULUM } from "../../Constants";

import BaseFrame from "../../component/wrapper/BaseFrame";
import { HomeLink } from "../../component/breadcrums/Links";
import ResultsArea from "./TrainingList/ResultsArea";
import SearchArea from "./TrainingList/SearchArea";
import { SompoSearchModeValue } from "../../component/mode/SompoSearchMode";

import {
    Category as CategoryDatum,
    CATEGORY_ID_CAREERS,
    CATEGORY_ID_CURRICULUMS,
    useCategories2,
    Categories,
    CATEGORIES_DEFAULT,
} from "../../logic/hook/useCategories";
import { useDivisions } from "../../logic/hook/useDivisions";
import SearchCareerClassListService, {
    SearchCareerClassListPayload,
    SearchCareerClassListResponse,
    CareerResultsItem,
} from "../../logic/api/SearchCareerClassListService";
import { showErrorMessage } from "../../logic/hook/useDialogStateHelper";
import SompoContext from "../../logic/context/SompoContext";
import { currentDate, DateFormats, parseJSDateTime } from "../../logic/datetime";

const searchCareerClassListService = new SearchCareerClassListService();

/** useLocationのState */
export interface LocationState {
    parentCategoryId?: string;
    categoryId?: string;
    searchMode?: SompoSearchModeValue;
}

/**
 * 検索条件
 */
interface RequiredItems {
    itemId?: string;
    companyId?: string;
}
interface RequiredDetail {
    type?: string;
    items?: RequiredItems[];
}
export interface SearchCondition {
    freeword?: string;
    startDate?: string;
    endDate?: string;
    elearning: boolean;
    shugo: boolean;
    categoryId: string;
    detail: RequiredDetail[] | [];
    careerType: number;
}

/**
 * 講座情報
 */
export interface Career extends CareerResultsItem {}

/**
 * フィルタリングコンポーネント
 */
export interface SearchFilter {
    [key: string]: string | number;
}

const getDisplayCareers = (paramCareers: Career[], searchMode: SompoSearchModeValue): Career[] => {
    // フィルタ
    const filtered = paramCareers.filter((career) => {
        const { classId, displayStartDateTime, displayEndDateTime, check, applyStartDateTime, applyEndDateTime } = career;
        const curDate = currentDate().getTime();
        // 表示期間で判定
        if (
            displayStartDateTime &&
            displayEndDateTime &&
            curDate >= parseJSDateTime(displayStartDateTime, DateFormats.YYYYMMDDHHMM)!.getTime() &&
            curDate <= parseJSDateTime(displayEndDateTime, DateFormats.YYYYMMDDHHMM)!.getTime()
        ) {
            return true;
        }
        return false;
    });

    switch (searchMode) {
        // 講座
        case TRAINING_TYPE_CAREER:
            return filtered.sort((a, b) =>
                chainedSort(
                    // かんたんクラス：申込期間(募集期間)、降順
                    // 個別指定クラス：講座の表示期間、降順
                    // 第一ソートを期間の開始日、第二ソートを期間の終了日とする
                    a,
                    b,
                    // 1 開始日 降順
                    (_a, _b) => {
                        const getCompareStartDate = (c: Career) => {
                            let compareStartDate = "";
                            if (c.classId === "CL000000") {
                                compareStartDate = c.displayStartDateTime;
                            } else {
                                compareStartDate = c.applyStartDateTime;
                            }
                            return parseJSDateTime(compareStartDate, DateFormats.YYYYMMDDHHMM);
                        };

                        const startA = getCompareStartDate(_a);
                        const startB = getCompareStartDate(_b);
                        return descDate(startA, startB);
                    },
                    // 2 終了日 降順
                    (_a, _b) => {
                        const getCompareEndDate = (c: Career) => {
                            let compareEndDate = "";
                            if (c.classId === "CL000000") {
                                compareEndDate = c.displayEndDateTime;
                            } else {
                                compareEndDate = c.applyEndDateTime;
                            }
                            return parseJSDateTime(compareEndDate, DateFormats.YYYYMMDDHHMM);
                        };

                        const endA = getCompareEndDate(_a);
                        const endB = getCompareEndDate(_b);
                        return descDate(endA, endB);
                    }
                )
            );

        // カリキュラム
        case TRAINING_TYPE_CURRICULUM:
            return filtered.sort((a, b) =>
                chainedSort(
                    // カリキュラムの表示期間、降順
                    // 第一ソートを期間の開始日、第二ソートを期間の終了日とする
                    a,
                    b,
                    // 1 開始日 降順
                    (_a, _b) => {
                        const getCompareStartDate = (c: Career) => parseJSDateTime(c.displayStartDateTime, DateFormats.YYYYMMDDHHMM);

                        const startA = getCompareStartDate(_a);
                        const startB = getCompareStartDate(_b);
                        return descDate(startA, startB);
                    },
                    // 2 終了日 降順
                    (_a, _b) => {
                        const getCompareEndDate = (c: Career) => parseJSDateTime(c.displayEndDateTime, DateFormats.YYYYMMDDHHMM);

                        const endA = getCompareEndDate(_a);
                        const endB = getCompareEndDate(_b);
                        return descDate(endA, endB);
                    }
                )
            );

        default: // 想定では到達しないコート
            return paramCareers;
    }
};

const Content = () => {
    // Hooks.
    const location = useLocation();
    const locationState = location.state as LocationState;
    const { fetchCategories } = useCategories2();
    const { requiredDivisions } = useDivisions();

    // States.
    const [searchMode, setSearchMode] = React.useState<SompoSearchModeValue>(locationState?.searchMode || TRAINING_TYPE_CAREER);
    const [careers, setCareers] = useState<Career[]>([]);
    const [categories, setCategories] = useState<Categories>(CATEGORIES_DEFAULT);

    // Context.
    const sompoContext = React.useContext(SompoContext); // ローディングアニメーションの表示用

    // Event handlers.
    // 検索対象(講座・カリキュラム)の変更時
    const handleSearchModeChanged = () => {
        setCareers([]);
    };

    // Logics.
    // 検索
    const search = (condition: SearchCareerClassListPayload) => {
        sompoContext.setLoading(true); // ローディング開始

        // 検索条件の補正
        const _condition = condition;

        // 検索対象
        switch (searchMode) {
            // カリキュラム
            case TRAINING_TYPE_CURRICULUM:
                _condition.elearning = false;
                _condition.shugo = false;
                break;

            // 講座・他：講座は画面の条件通り
            case TRAINING_TYPE_CAREER:
            default:
                break;
        }
        // 通信教育は必ず検索対象外
        _condition.tuusin = false;

        // 分類
        if (_condition.categoryId === CATEGORY_ID_CAREERS || _condition.categoryId === CATEGORY_ID_CURRICULUMS || _condition.categoryId === "") {
            // カテゴリ すべて の時
            delete _condition.categoryId;
            delete _condition.lowerFlg;
        } else {
            // カテゴリが選択されているとき
            _condition.lowerFlg = true;
        }

        // 実効の検索条件
        const actualCondition = Object.fromEntries(
            (Object.entries(_condition) || []).filter(([name, v]) => {
                if (v === undefined) return false;
                if (["careerType", "elearning", "shugo", "tuusin"].includes(name)) return true;
                if (typeof v === "boolean") return true;
                return (v || "").length !== 0;
            })
        );

        // fetch
        // console.log("search: condition", condition);
        // console.log("search: _condition", _condition);
        // console.log("search: actualCondition", actualCondition);
        const fetch = async () => {
            try {
                const newCareers: Career[] = [];
                await searchCareerClassListService.searchCareerClassList(
                    { ...actualCondition },
                    (response: SearchCareerClassListResponse) => {
                        (response.careerResults as Career[]).forEach((career: Career) => {
                            newCareers.push(career);
                        });
                    },
                    (error: any) => {
                        throw error;
                    }
                );
                const _categories: Categories = await fetchCategories();
                setCareers(getDisplayCareers(newCareers, searchMode));
                setCategories(_categories);
                sompoContext.setLoading(false); // ローディング終了
            } catch (error: unknown) {
                console.error(error);
                showErrorMessage({ message: "講座情報の検索に失敗しました。", error });
                setCareers([]);
                sompoContext.setLoading(false); // ローディング終了
            }
        };
        if (!Environments.MOCK) {
            fetch();
        } else {
            const newCareers: Career[] = [];
            (MOCK_DATA.TRAINING[0].rows as Career[]).forEach((datum: Career) => newCareers.push(datum));
            setCareers(newCareers);
            sompoContext.setLoading(false); // ローディング終了
        }
    };

    // カテゴリ用
    let getLevelCategoriesFn: (parentId: string) => CategoryDatum[] | undefined;
    switch (searchMode) {
        case TRAINING_TYPE_CURRICULUM:
            getLevelCategoriesFn = categories.getLevelCategoriesCurriculum;
            break;
        case TRAINING_TYPE_CAREER:
        default:
            getLevelCategoriesFn = categories.getLevelCategories;
            break;
    }

    // Render component.
    return (
        <Grid container direction="column" spacing={1} sx={{ mt: 2 }}>
            {/** 結果件数表示エリア */}
            <Typography sx={{ pl: 1, mb: 1, fontWeight: "bold", wordBreak: "break-all" }}>{`検索結果：${careers.length}件`}</Typography>

            {/** 検索条件エリア */}
            <SearchArea
                locationState={locationState}
                searchMode={searchMode}
                setSearchMode={setSearchMode}
                handleSearchModeChanged={handleSearchModeChanged}
                requiredDivisions={requiredDivisions}
                showCurriculumsFn={categories.showCurriculums}
                getLevelCategoriesFn={getLevelCategoriesFn}
                search={search}
            />

            {/** 検索結果一覧 */}
            <ResultsArea searchMode={searchMode} careers={careers} />
        </Grid>
    );
};

const MainContent = memo(Content);

const TrainingList = () => <BaseFrame width="90%" title="検索一覧" breadcrumbs={[<HomeLink />]} content={<MainContent />} />;

export default TrainingList;
